goog.provide('yext.location.Phones');
goog.provide('yext.location.PhonesModel');

goog.require('yext');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.storm.routesDEPRECATED');
goog.require('yext.location.helpers');

/**
 * Model for the phones field
 *
 * @constructor
 * @author Yi Liu (yliu@yext.com)
 */
yext.location.PhonesModel = function(options) {
  this.options = options;
  this.phones = [];
};

/**
 * Update the phone data on the model
 *
 * @param {PhonesModel.Phone} phone The phone being updated
 * @param {!Object} update The updated phone
 */
yext.location.PhonesModel.prototype.updatePhone = function(phone, update) {
  var changed = phone.update(update);
  if (changed) {
    this.message('updated');
  }
  return changed;
};

/**
 * Update the options data on the model
 *
 * @param {!Object} update The updated options
 * @return {boolean} True if the options get updated
 */
yext.location.PhonesModel.prototype.updateOptions = function(update) {
  var changed = false;
  if (yext.isBoolean(update.isDisplayNumberChecked) && update.isDisplayNumberChecked != this.options.isDisplayNumberChecked) {
    changed = true;
    this.options.isDisplayNumberChecked = update.isDisplayNumberChecked;
  }
  if (yext.isBoolean(update.isTollFreeNumber) && update.isTollFreeNumber != this.options.isTollFreeNumber) {
    changed = true;
    this.options.isTollFreeNumber = update.isTollFreeNumber;
  }
  if (yext.isBoolean(update.mainIsTrackedIndeterminate) && update.mainIsTrackedIndeterminate != this.options.mainIsTrackedIndeterminate) {
    changed = true;
    this.options.mainIsTrackedIndeterminate = update.mainIsTrackedIndeterminate;
  }

  if (changed) {
    this.message('updated');
  }
};

/**
 * Trigger a message on the PhonesModel
 *
 * @param {string} message Message to trigger
 */
yext.location.PhonesModel.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * The phone model for each phone field
 * @constructor
 */
yext.location.PhonesModel.Phone = function(data) {
  this.value = data.value;
  this.type = data.type;
  this.displayName = data.displayName;
  this.indeterminate = data.indeterminate;
};

/**
 * Return true if the phone is updated
 *
 * @param {!Object} update The updated phone
 * @return {boolean} True if the value gets updated
 */
yext.location.PhonesModel.Phone.prototype.update = function(update) {
  var changed = false;
  if (update.value !== this.value) {
    changed = true;
    this.value = update.value;
    this.indeterminate = false;
  }
  return changed;
};

/**
 * Get a copy of the phone data
 *
 * @return {!Object} Model properties
 */
yext.location.PhonesModel.Phone.prototype.getData = function() {
  return {
    value: this.value,
    type: this.type,
    displayName: this.displayName,
    indeterminate: this.indeterminate,
  };
};

/**
 * Data keyed on strings for export
 *
 * @return {!Object} Model properties keyed with strings
 */
yext.location.PhonesModel.Phone.prototype.getDataForExport = function() {
  return {
    'type': this.type,
    'value': this.value,
    'indeterminate': this.indeterminate,
  };
};

/**
 * @param {!jQuery} $ctx Parent element for the field
 * @constructor
 */
yext.location.Phones = function($ctx) {
  this.$ctx = $ctx;
  this.$addPhoneLink = this.$ctx.find('.js-add-more-phone-numbers');
  this.$secondaryPhones = this.$ctx.find('.js-secondary-phones');
  this.$displayCheckbox = this.$ctx.find('.js-display-number-checkbox');
  this.$localPhoneRow = this.$ctx.find('input[data-type="LOCAL"]').closest('.js-phone-row');
  this.$tollFreeMessage = this.$ctx.find('.js-toll-free-message');
  this.$displayMessage = this.$ctx.find('.js-display-message');
  this.$displayNumberUncheckDialog = this.$ctx.find('.js-phone-display-number-uncheck-dialog');

  this.country = this.$ctx.find('.js-phone-country').val();
  this.fieldName = this.$ctx.find('input[name="field"]').val();

  var options = {
    isDisplayNumberChecked: this.$displayCheckbox.is(':checked'),
    mainIsTrackedIndeterminate: this.$displayCheckbox.data('indeterminate'),
    isTollFreeNumber: this.$tollFreeMessage.is(':visible'),
    indeterminate: this.$ctx.data('isVarious'),
  };
  this.model = new yext.location.PhonesModel(options);
  this.storedModel = {};

  this.parsePhonesFromDOM();
  this.storeValue();
  this.bindUpdates();
  this.bindAddPhone();
  this.bindDisplayCheckbox();
};

/**
 * Parse the initial state of phones list from the DOM
 */
yext.location.Phones.prototype.parsePhonesFromDOM = function() {
  var self = this;

  this.$ctx.find('.js-phone-row').each(function() {
    self.parsePhoneFromDOM($(this));
  });
};

/**
 * Parse the initial state of a single phone from the DOM
 *
 * @param {!jQuery} $el The experience element
 */
yext.location.Phones.prototype.parsePhoneFromDOM = function($el) {
  var self = this;

  $el.find('.js-phone-input').each(function() {
    var $input = $(this);
    var phone = new yext.location.PhonesModel.Phone({
      value: $input.val(),
      type: $input.data('type'),
      indeterminate: $input.data('indeterminate'),
    });
    self.model.phones.push(phone);

    self.bindPhoneInputUpdate($input, phone);
  });
};

/**
 * Bind the phone input text update
 *
 * @param {!jQuery} $phoneInput Phone value input container
 * @param {PhonesModel.Phone} phone The phone being updated
 */
yext.location.Phones.prototype.bindPhoneInputUpdate = function($phoneInput, phone) {
  var self = this;

  $phoneInput.inputchange(function() {
    var update = {
      value: $(this).val(),
    };
    var changed = self.model.updatePhone(phone, update);

    if ($(this).data('type') === 'MAIN' && changed) {
      self.checkMainPhoneForTollFree($(this));
    }
  });
};

/**
 * Issue an AJAX request to check if the number is toll-free in the current country
 * only when the number of digits is 10 or more
 *
 * @param {!jQuery} $input The main phone value input container
 */
yext.location.Phones.prototype.checkMainPhoneForTollFree = function($input) {
  var self = this;

  var phone = $input.val();
  var digits = phone.replace(/[^0-9]/g, '');
  if (digits.length >= 10) {
    var checkTollFreeUrl = yext.storm.routesDEPRECATED.LocationEdit.checkTollFreeNumber({
      'country': this.country,
      'phoneNumber': digits,
    });

    $.ajax({
      url: checkTollFreeUrl,
      success: function(isTollFree, status, jqXHR) {
        var options = {isTollFreeNumber: false};
        if (isTollFree) {
          options = {
            isTollFreeNumber: true,
            isDisplayNumberChecked: true,
          };
        }
        self.model.updateOptions(options);
      },
    });
  } else {
    this.model.updateOptions({isTollFreeNumber: false});
  }
};

/**
 * Store the state for use in reset
 */
yext.location.Phones.prototype.storeValue = function() {
  var options = $.extend({}, this.model.options);
  this.storedModel = new yext.location.PhonesModel(options);
  for (var i = 0; i < this.model.phones.length; i++) {
    this.storedModel.phones.push(this.model.phones[i].getData());
  }
};

/**
 * Listen for updates from the model and broadcasts an update message
 */
yext.location.Phones.prototype.bindUpdates = function() {
  var self = this;

  $(this.model).on('updated', function() {
    self.render();
    self.message('updated');
  });
};

/**
 * Broadcast messages with the field as context
 *
 * @param {string} message Message to trigger
 */
yext.location.Phones.prototype.message = function(message) {
  $(this).trigger(message);
};

/**
 * Bind the add more phone numbers link
 */
yext.location.Phones.prototype.bindAddPhone = function() {
  var self = this;

  this.$addPhoneLink.on('click', function() {
    self.$secondaryPhones.show();
    $(this).hide();
  });
};

/**
 * Bind the display phone number checkbox
 * @suppress {deprecated}
 */
yext.location.Phones.prototype.bindDisplayCheckbox = function() {
  var self = this;

  if (this.$displayCheckbox.data('indeterminate')) {
    this.$displayCheckbox.prop('indeterminate', true);
  }

  this.$displayNumberUncheckDialog.dialog({
    modal: true,
    autoOpen: false,
    draggable: false,
    resizable: false,
    minWidth: 355,
    title: yext.msg('Are you sure?'),
  });

  this.$displayNumberUncheckDialog.find('button').click(function() {
    self.$displayNumberUncheckDialog.dialog('close');
  });

  this.$displayCheckbox.on('click', function() {
    var options = {};
    if ($(this).is(':checked')) {
      options = {
        isDisplayNumberChecked: true,
        mainIsTrackedIndeterminate: false,
      };
    } else {
      options = {
        isDisplayNumberChecked: false,
        mainIsTrackedIndeterminate: false,
      };
      self.$displayNumberUncheckDialog.dialog('open');
    }
    self.model.updateOptions(options);
  });
};

/**
 * Reset the field to a stored state
 */
yext.location.Phones.prototype.reset = function() {
  this.set(this.storedModel);
};

/**
 * Set the fields value
 *
 * @param {!Object} field Field data
 */
yext.location.Phones.prototype.set = function(field) {
  this.model.options = $.extend({}, field.options);

  this.model.phones = [];
  for (var i = 0; i < field.phones.length; i++) {
    var phone = new yext.location.PhonesModel.Phone(field.phones[i]);
    this.model.phones.push(phone);
  }

  this.model.message('updated');
};

/**
 * Render the current state of the model
 */
yext.location.Phones.prototype.render = function() {
  var $phonesDOM = this.$ctx.find('.js-phone-row');
  var localPhoneIndeterminate = false;
  for (var i = this.model.phones.length - 1; i >= 0; i--) {
    var phone = this.model.phones[i];
    var $phoneInput = $($phonesDOM.get(i)).find('.js-phone-input');
    if ($phoneInput.val() != phone.value) {
      $phoneInput.val(phone.value);
    }
    $phoneInput.off();
    this.bindPhoneInputUpdate($phoneInput, phone);

    if (phone.type === 'LOCAL' && phone.indeterminate) {
      localPhoneIndeterminate = true;
    }
  }

  this.$addPhoneLink.toggle(!this.shouldShowSecondaryPhones());
  this.$secondaryPhones.toggle(this.shouldShowSecondaryPhones());

  var showTollFreeMsg = this.model.options.isTollFreeNumber;
  var showDisplayMsg = !this.model.options.isTollFreeNumber && this.model.options.isDisplayNumberChecked;
  var showLocalPhone = showTollFreeMsg || showDisplayMsg || this.model.options.mainIsTrackedIndeterminate || localPhoneIndeterminate;
  this.$tollFreeMessage.toggle(showTollFreeMsg);
  this.$displayMessage.toggle(showDisplayMsg);
  this.$localPhoneRow.toggle(showLocalPhone);
  if (this.model.options.mainIsTrackedIndeterminate) {
    this.$displayCheckbox.prop('indeterminate', true);
  } else {
    this.$displayCheckbox.prop('indeterminate', false);
    this.$displayCheckbox.prop('checked', showLocalPhone);
    this.$displayCheckbox.prop('disabled', showTollFreeMsg);
  }
};

yext.location.Phones.prototype.shouldShowSecondaryPhones = function() {
  for (var i = 0; i < this.model.phones.length; i++) {
    var phone = this.model.phones[i];
    if (phone.type === 'MAIN' || phone.type === 'LOCAL') {
      continue;
    }
    if (phone.value || phone.indeterminate) {
      return true;
    }
  }
  return false;
};

/**
 * Get the current state of the field as a JSON string
 *
 * @return {string} JSON string of field
 */
yext.location.Phones.prototype.getJSONData = function() {
  var phones = [];
  for (var i = 0; i < this.model.phones.length; i++) {
    var phone = this.model.phones[i];
    if (!this.model.options.isDisplayNumberChecked && phone.type === 'LOCAL') {
      phone.value = '';
    }
    phones.push(phone.getDataForExport());
  }
  var data = {
    'phones': phones,
  };
  if (!this.model.options.mainIsTrackedIndeterminate) {
    data['mainIsTracked'] = this.model.options.isDisplayNumberChecked && !this.model.options.isTollFreeNumber;
  }
  return yext.JSON.stringify(data);
};

/**
 * Get the display value for the field
 *
 * @return {string} phones list html string
 */
yext.location.Phones.prototype.getDisplayValue = function() {
  if (this.model.options.indeterminate) {
    return yext.location.helpers.variousContentMessage();
  } else {
    var rows = [];
    for (var i = 0; i < this.model.phones.length; i++) {
      var phone = this.model.phones[i];
      if (phone.value) {
        rows.push('<tr><td>' + phone.displayName + ':</td><td>' + phone.value + '</td></tr>');
      }
    }
    if (rows.length) {
      var display = '<table class="phones-table" cellspacing="0"><tbody>';
      display += rows.join('');
      display += '</tbody></table>';
      return display;
    } else {
      return yext.location.helpers.emptyFieldMessage();
    }
  }
};
